<template>
  <div id="overview">
    <v-row v-if="showGraphs">
      <v-col cols="12" :md="adUnitType ? 6 : 12" class="chart-container">
        <base-material-card
            id="chartist-revenues"
            color="#009f4c"
            icon="fas fa-piggy-bank"
            class="px-4 py-3 revenue_card">

          <template v-slot:after-heading>
            <div class="display-1 font-weight-light mt-2">
              Revenue
              <span class="subtitle-1"></span>

            </div>
          </template>

          <chartist
              :data="overviewRevenuesLineChart.data"
              :options="overviewRevenuesLineChart.options"
              :responsive-options="overviewRevenuesLineChart.responsiveOptions"
              color="default"
              type="Line"
              style="max-height: 150px;"
              class="mt-3"
          />

          <v-btn app dark fab absolute top right
                 color="#009f4c"
                 style="margin-top: 40px;"
                 v-on:click="dialogRevenueChanged">
            <v-icon style="font-size: 24px;">mdi-magnify-plus-outline</v-icon>
          </v-btn>

        </base-material-card>
      </v-col>
      <v-col cols="12" md="6" class="chart-container" v-if="adUnitType">
        <base-material-card
            id="chartist-rpm"
            color="#edaa3f"
            icon="fas fa-euro-sign"
            class="px-4 py-3 rpm_card">
          <template v-slot:after-heading>
            <div class="display-1 font-weight-light mt-2">
              CPM
              <span class="subtitle-1"></span>
            </div>
          </template>

          <chartist

              :data="overviewRPMLineChart.data"
              :options="overviewRPMLineChart.options"
              :responsive-options="overviewRPMLineChart.responsiveOptions"
              color="white"
              type="Line"
              style="max-height: 150px;"
              class="mt-3"
          />

          <v-btn app dark fab absolute top right
                 color="#edaa3f"
                 style="margin-top:40px;"
                 v-on:click="dialogCPMChanged">
            <v-icon style="font-size: 24px;">mdi-magnify-plus-outline</v-icon>
          </v-btn>
        </base-material-card>

      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" lg="4">
        <stats-card
            color="requests"
            title="Request"
            icon="true"
            :value="reports.overview.requests | integer"
        >
          <template #icon>
            <request-icon></request-icon>
          </template>
        </stats-card>
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <stats-card
            color="impressions"
            title="Impression"
            icon="true"
            :value="reports.overview.impressions | integer"
        >
          <template #icon>
            <impressions-icon></impressions-icon>
          </template>
        </stats-card>
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <stats-card
            color="fillRate"
            title="Fill-rate"
            icon="true"
            :value="reports.overview.fill_rate | decimals | percent"
            tooltip="(Impression/Request)*100"
        >
          <template #icon>
            <fill-rate-icon></fill-rate-icon>
          </template>
        </stats-card>
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <stats-card
            color="clicks"
            icon="fas fa-mouse-pointer"
            title="Click"
            :value="reports.overview.clicks | integer"
        >
          <template #icon>
            <click-icon></click-icon>
          </template>
        </stats-card>
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <stats-card
            color="ctr"
            icon="fas fa-mouse-pointer"
            title="CTR"
            :value="reports.overview.ctr | decimals | percent"
            tooltip="(Click/Impression)*100"
        >
          <template #icon>
            <c-t-r-icon></c-t-r-icon>
          </template>
        </stats-card>
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <stats-card
            color="viewability"
            icon="fas fa-eye"
            title="Viewability"
            :value="reports.overview.viewability | decimals | percent"
        >
          <template #icon>
            <viewability-icon></viewability-icon>
          </template>
        </stats-card>
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <stats-card
            color="rpm"
            icon="fas fa-euro-sign"
            title="eCPM"
            :value="reports.overview.rpm | decimals | eur"
            tooltip="(Revenue stimate/Request)*1000"
        >
          <template #icon>
            <r-p-m-icon></r-p-m-icon>
          </template>
        </stats-card>

      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <stats-card
            color="cpm"
            icon="fas fa-euro-sign"
            title="CPM"
            :value="reports.overview.cpm | decimals | eur"
            tooltip="(Revenue stimate/Impression)*1000"
        >
          <template #icon>
            <c-p-m-icon></c-p-m-icon>
          </template>
        </stats-card>
      </v-col>
      <v-col cols="12" sm="6" lg="4">

        <stats-card
            color="revenues"
            icon="fas fa-piggy-bank"
            title="Revenue stimate"
            :value="reports.overview.revenues | decimals | eur"
        >
          <template #icon>
            <revenues-icon></revenues-icon>
          </template>
        </stats-card>
      </v-col>

    </v-row>
  </div>
</template>

<script>

import RequestIcon from '../icons/RequestIcon'
import StatsCard from '../../../components/StatsCard'
import ImpressionsIcon from '../icons/ImpressionstIcon'
import FillRateIcon from '../icons/FillRateIcon'
import ViewabilityIcon from '../icons/ViewabilityIcon'
import ClickIcon from '../icons/ClickIcon'
import CTRIcon from '../icons/CTRIcon'
import CPMIcon from '../icons/CPMIcon'
import RPMIcon from '../icons/RPMIcon'
import RevenuesIcon from '../icons/RevenuesIcon'

const chartOptions = {
  options: {
    low: 0,
    // high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
    chartPadding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    showPoint: false,
    fullWidth: true,
    showArea: true
  },
  responsiveOptions: [
    ['screen and (max-width: 640px)', {
      // seriesBarDistance: 5,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value[0]
        }
      }
    }]
  ]
}

export default {
  name: 'Overview',
  components: {
    RevenuesIcon,
    RPMIcon,
    CPMIcon,
    CTRIcon,
    ClickIcon,
    ViewabilityIcon,
    FillRateIcon,
    ImpressionsIcon,
    StatsCard,
    RequestIcon
  },
  props: ['reports', 'showGraphs', 'adUnitType'],
  mounted() {
    console.log("Overview mounted");
    console.log(this.adUnitType);
  },
  computed: {
    overviewRevenuesLineChart() {
      const data = {labels: [], series: [[]]}

      if (!this.reports) return Object.assign(chartOptions, {data: data})

      _.each(this.reports.daily, (val, key) => {
        data.labels.push(key)
        data.series[0].push(val.revenues)
      })

      return Object.assign(chartOptions, {data: data})
    },
    overviewRPMLineChart() {
      const data = {labels: [], series: [[], []]}

      if (!this.reports) return Object.assign(chartOptions, {data: data})

      _.each(this.reports.daily, (val, key) => {
        data.labels.push(key)
        data.series[0].push(val.cpm)
        // data.series[1].push(val.rpm);
      })
      // console.log("SADASDASD")
      // console.log(Object.assign(chartOptions,{data:data}))
      return Object.assign(chartOptions, {data: data})
    }
  },
  filters: {
    integer(val) {
      return Number(val).toLocaleString(undefined, {maximumFractionDigits: 2})
    },
    decimals(val) {
      return Number(val).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    },
    percent(val) {
      return val + '%'
    },
    eur(val) {
      return val + ' €'
    }
  },
  methods: {
    dialogRevenueChanged: function () {
      console.log('overview emit: Update value  dialogRevenue')
      this.$emit('dialogRevenueChanged', true)
    },
    dialogCPMChanged: function () {
      console.log('overview emit: Update value dialogCPM')
      this.$emit('dialogCPMChanged', true)
    }
  }
}
</script>

<style lang="sass">
#chartist-rpm
  .ct-series-a .ct-line,
  .ct-series-a .ct-point
    stroke: #edaa3f !important

  .ct-series-a .ct-area
    fill: #edaa3f !important

  svg.svg-inline--fa
    width: 32px !important
    height: 32px !important

  .v-card--material__heading
    padding: 22px 20px 22px 20px !important

#chartist-revenues
  .ct-series-a .ct-line,
  .ct-series-a .ct-point
    stroke: #009f4c !important

  .ct-series-a .ct-area
    fill: #009f4c !important

  svg.svg-inline--fa
    width: 37px !important
    height: 37px !important

  .v-card--material__heading
    padding: 20px 18px 20px 18px !important

</style>
